import {cloudSvg as Icon__small__cloudSvg} from '../Icon__small/Icon__small--cloud.js';

export var cloud = {
  name: 'cloud',
  category: 'icon',
  colorable: true,
  svg: Icon__small__cloudSvg,
};
